export default __webpack_public_path__ + "static/media/or-6.1de2d82b.jpg";